<template>
  <div class="max-w-full p-4">
    <div class="mx-auto container">
      <div class="mx-auto w-full text-center py-8">
        <div v-if="showHeading" class="text-oswald">
          <span class="text-6xl text-primary">market</span
          ><span class="text-6xl text-secondary">analyzer</span>
        </div>
        <!-- test cache busting -->
        <!-- <div class="text-gray-500">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur
          pretium ante quis mauris viverra aliquam. Donec mauris leo, convallis
          nec tincidunt nec, egestas quis dui. Pellentesque dapibus, felis sit
          amet vestibulum tempor.
        </div> -->
      </div>
      <div class="">
        <form action="#" method="POST" class="grid grid-cols-1 row-gap-6">
          <div class="py-8">
            <google-places-select v-model="place"></google-places-select>
            <div class="mt-4 ml-4 pl-1 text-gray-500 cursor-pointer relative" @mouseover="tooltip = true" @mouseleave="tooltip = false">
              Having trouble finding a business?
            </div>
            <div v-if="tooltip" class="absolute shadow-lg rounded-lg p-4 text-gray-700 mt-3 bg-gray-200">
              Try including the city or state <br />
              where the business is located.
              <div class="triangel"></div>
            </div>
          </div>
          <!-- <div class="mt-6">
            <search-select
              placeholder="OEM Name"
              label="Select OEM"
              v-model="selectedOEM"
              :items="$store.state.oems"
              itemText="name"
            ></search-select>
          </div> -->
          <div>
            <div class="mx-auto w-full mt-12">
              <div class="my-4 text-xl text-primary text-sans font-bold">
                Select your preferred geographic targeting
              </div>
              <div class="text-gray-500">
                The primary and secondary markets are a circular radius in miles
                around the location selected above.
              </div>
              <div class="flex items-center mt-6 text-gray-600">
                <div class="mx-4 w-1/6 text-secondary font-bold text-lg">
                  Primary
                </div>
                <div class="flex-1 m-2">
                  <input-range
                    :min="1"
                    :max="50"
                    v-model="primaryTargetingRadius"
                  ></input-range>
                </div>
                <div class="mx-4 text-center w-1/6 text-lg text-sans">
                  <span class="text-primary font-bold">{{
                    primaryTargetingRadius
                  }}</span
                  ><span class="text-secondary font-bold"> miles</span>
                </div>
              </div>
              <div class="flex items-center mt-6 text-gray-600">
                <div class="mx-4 w-1/6 text-secondary font-bold text-lg">
                  Secondary
                </div>
                <div class="flex-1 m-2">
                  <input-range
                    type="range"
                    :min="1"
                    :max="50"
                    v-model="secondaryTargetingRadius"
                  ></input-range>
                </div>
                <div class="mx-4 text-center w-1/6 text-lg text-sans">
                  <span class="text-primary font-bold">{{
                    secondaryTargetingRadius
                  }}</span
                  ><span class="text-secondary font-bold"> miles</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="mx-auto w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 mt-12">
              <button
                class="w-full p-3 rounded text-gray-100 shadow text-center uppercase font-medium text-xl"
                :class="
                  valid
                    ? 'bg-primary cursor-pointer hover:shadow-lg'
                    : 'bg-gray-500 cursor-default'
                "
                :disabled="!valid"
                @click.prevent="getResults()"
              >
                Get Results
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import inputRange from "../components/inputs/Range";
import googlePlacesSelect from "../components/inputs/GooglePlacesSelect";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("whiteLabel");

export default {
  components: { inputRange, googlePlacesSelect },
  data() {
    return {
      place: {},
      selectedOEM: "",
      primaryTargetingRadius: 15,
      secondaryTargetingRadius: 30,
      tooltip: false
    };
  },
  methods: {
    getResults() {
      //TODO: Validation here
      this.$router.push({
        name: "results",
        query: {
          placeId: this.place.place_id,
          primaryRadius: this.primaryTargetingRadius,
          secondaryRadius: this.secondaryTargetingRadius
        }
      });
    }
  },
  computed: {
    ...mapGetters(["showHeading"]),
    valid: function() {
      return this.place.place_id ? true : false;
    }
  }
};
</script>

<style scoped>
.triangel {    
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -10px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent #edf2f7 transparent;
}
</style>